// ═══════════════════════════════════
// SALES PORTAL — Constants & Config
// ═══════════════════════════════════

export const COLORS = {
  bg: '#0a0e17',
  surface: '#111827',
  surfaceAlt: '#1a2233',
  border: '#1e293b',
  borderHover: '#334155',
  accent: '#f59e0b',
  accentDim: '#b45309',
  accentGlow: 'rgba(245, 158, 11, 0.15)',
  blue: '#3b82f6',
  blueDim: '#1e40af',
  blueGlow: 'rgba(59, 130, 246, 0.15)',
  green: '#10b981',
  greenDim: '#047857',
  red: '#ef4444',
  purple: '#8b5cf6',
  text: '#f1f5f9',
  textMuted: '#94a3b8',
  textDim: '#64748b',
};

export const API_CONFIG = {
  anthropic: import.meta.env.VITE_ANTHROPIC_API_URL || 'https://api.anthropic.com/v1/messages',
  getResponse: import.meta.env.VITE_GETRESPONSE_API_URL || 'https://api.getresponse.com/v3',
  // In production, API calls go through Netlify functions or Railway
  apiBase: import.meta.env.VITE_APP_URL || '',
};

export const TABS = [
  { id: 'dashboard', label: 'Dashboard', icon: '◆' },
  { id: 'prospect', label: 'Prospect', icon: '⊕' },
  { id: 'contacts', label: 'Contacts', icon: '◎' },
  { id: 'companies', label: 'Companies', icon: '▣' },
  { id: 'ai-tools', label: 'AI Tools', icon: '✦' },
  { id: 'campaigns', label: 'Campaigns', icon: '◈' },
  { id: 'getresponse', label: 'GetResponse', icon: '▶' },
];

export const LEAD_GRADES = {
  A: { color: '#10b981', label: 'Hot Lead' },
  B: { color: '#3b82f6', label: 'Warm Lead' },
  C: { color: '#f59e0b', label: 'Lukewarm' },
  D: { color: '#f97316', label: 'Cold Lead' },
  F: { color: '#ef4444', label: 'Unqualified' },
};
